/**
 * Motivos rápidos cuando el cuadre de transferencias no coincide.
 */

export const CUADRE_TRANSFERENCIA_MOTIVOS = [
  { value: "comprobante_falso", label: "Comprobante falso / editado" },
  { value: "no_llego", label: "El comprobante nunca llegó" },
  { value: "monto_distinto", label: "Monto del comprobante distinto" },
  { value: "duplicado", label: "Cobro duplicado en app" },
  { value: "cliente_pago_otro", label: "Cliente pagó por otro canal" },
  { value: "otro", label: "Otro (detallar abajo)" },
] as const;

export type CuadreTransferenciaMotivo =
  (typeof CUADRE_TRANSFERENCIA_MOTIVOS)[number]["value"];

export const CUADRE_DETALLE_MIN_CHARS = 10;

export function cuadreExplicacionValida(
  motivo: CuadreTransferenciaMotivo | "",
  detalle: string,
): boolean {
  if (!motivo) return false;
  if (motivo !== "otro") return true;
  return detalle.trim().length >= CUADRE_DETALLE_MIN_CHARS;
}
